export default __webpack_public_path__ + "static/media/RESCUE.b6a9ea1b.mp3";